// extracted by mini-css-extract-plugin
export default {"reportName":"style--reportName--24eacf","salonName":"style--salonName--691931","row":"style--row--a7eab2","actionButtons":"style--actionButtons--755168"};